<span class="badge badge-success mx-4" style="font-size: 1.2em;">{{
  total | currency : "ARS" : "symbol" : undefined : "es-AR"
}}</span>
